// Client for the cut endpoints (same-origin Pages Functions).
// PROTOTYPE (clip player). Creating a cut requires the fan's Supabase session
// bearer (F1, review 2026-08-26 — the endpoint spends real money, so spend is
// authenticated and budgeted per fan). The bearer is passed IN by the caller
// rather than imported here, so /watch and /reel — which only ever GET public
// cuts — keep their no-auth, no-Supabase bundles. No profile data travels on
// either call; this is still the one show-side request that carries a
// free-text query (see README).

import type {Cut} from '../shared/cuts'

/** deep_answer synthesizes server-side; the whole round trip can take ~1–2 min. */
const CREATE_TIMEOUT_MS = 150_000

export async function createCut(
  query: string,
  accessToken: string | null,
): Promise<{cut: Cut; saved: boolean}> {
  if (!accessToken) {
    // Mirror the server's 401 without spending the round trip.
    throw new Error('sign in to use the cutting room — cuts spend real search time, so they need a signed-in fan')
  }
  const res = await fetch('/api/cuts', {
    method: 'POST',
    headers: {'content-type': 'application/json', authorization: `Bearer ${accessToken}`},
    body: JSON.stringify({query}),
    signal: AbortSignal.timeout(CREATE_TIMEOUT_MS),
  })
  const data = (await res.json()) as {ok?: boolean; cut?: Cut; saved?: boolean; error?: string}
  if (!data.ok || !data.cut) throw new Error(data.error ?? `cut request failed (HTTP ${res.status})`)
  return {cut: data.cut, saved: Boolean(data.saved)}
}

export async function getCut(id: string): Promise<Cut> {
  const res = await fetch(`/api/cuts/${encodeURIComponent(id)}`)
  const data = (await res.json()) as {ok?: boolean; cut?: Cut; error?: string}
  if (!data.ok || !data.cut) throw new Error(data.error ?? `cut ${id} failed to load (HTTP ${res.status})`)
  return data.cut
}

export function watchUrl(cutId: string): string {
  return `${window.location.origin}/watch/${cutId}`
}
